import {
  laravelGet,
  laravelPost,
  laravelPut,
  laravelDelete,
} from '../utils/laravelClient';
import { fetchAllBrands } from './brandApi';
import { updateFlavorInState } from '../features/flavors/flavorsSlice';

const AUTH = { auth: 'admin' };

/**
 * Fetches all active flavors (across all brands)
 */
export const fetchActiveFlavors = async () => {
  const brands = await fetchAllBrands();
  return brands
    .flatMap((brand) => brand.flavours || [])
    .filter((flavor) => flavor.is_active);
};

export const fetchInactiveFlavorRequest = () =>
  laravelGet('/inactive-request', AUTH);

export const submitInactiveFlavorRequest = (ids) =>
  laravelPost('/inactive-request', { ids }, AUTH);

export const updateInactiveFlavorRequest = (requestId, ids) =>
  laravelPut(`/inactive-request/${requestId}`, { ids }, AUTH);

export const deleteInactiveFlavorRequest = (requestId) =>
  laravelDelete(`/inactive-request/${requestId}`, AUTH);

export const executeInactiveFlavorRequest = () =>
  laravelPost('/inactive-request/execute', null, AUTH);

export const fetchInactiveFlavourDeactivations = (params = {}) =>
  laravelGet('/inactive-request-deactivations', { ...AUTH, params });

export const revertInactiveFlavourDeactivations = (flavourIds) =>
  laravelPost('/inactive-request/revert', { flavour_ids: flavourIds }, AUTH);

export const getFlavor = (flavorId) =>
  laravelGet(`/flavours/${flavorId}`, AUTH);

export const updateFlavorStatus = (flavorId, isActive) =>
  laravelPut(`/flavours/${flavorId}`, { is_active: isActive }, AUTH);

export const updateFlavor = async (flavorId, flavorData, dispatch) => {
  const updatedFlavor = await laravelPut(`/flavours/${flavorId}`, flavorData, AUTH);
  if (dispatch) {
    dispatch(updateFlavorInState(updatedFlavor));
  }
  return updatedFlavor;
};

export const getAllBrands = () => fetchAllBrands();

export const createFlavor = (flavorData) =>
  laravelPost('/flavours', flavorData, AUTH);

export const deleteFlavor = (flavorId) =>
  laravelDelete(`/flavours/${flavorId}`, AUTH);
